<template>
  <tr class="operative-table-body-row-empty">
    <template v-for="i in columns">
      <td :key="i"><span>&nbsp;</span></td>
    </template>
  </tr>
</template>

<script>

export default {
  name: 'operative-table-body-row',
  props: {
    years: {
      type: Array,
      default: () => [],
    },
    fixedNumColumns: {
      type: Number,
      default: null,
    },
  },
  computed: {
    numColumns () {
      return (this.years?.length || 0) + 1;
    },
    columns () {
      return Array(this.fixedNumColumns || this.numColumns);
    },
  },
};

</script>

<style lang="scss">

.operative-table-body-row-empty {
  td {
    height: 21px;
  }
}

</style>
